import {fetchWithAuth} from '../lib/api';
import type {QueuedShotCopy} from './shotCopyService';

/** PKT-0864 P2 · R-HW1: the box could not find a feature Grant's words name in the building's website facts.
 *  PKT-0884: approving them saves HUMAN-APPROVED WORDING for that building, never a building fact or an amenity. */
export interface ClaimFeature {key:string;label:string}
export interface ClaimWarningLine {scene_id:string;text:string;features:ClaimFeature[];records_say:string|null}
export interface ClaimWarning {refused_request_id:string;building:string;warnings:ClaimWarningLine[];edits:QueuedShotCopy['edits']}

const str=(v:unknown):v is string=>typeof v==='string';
/** Strict: anything malformed is `null`, and the screen falls back to the plain refusal. It never guesses. */
export function parseClaimWarning(raw:unknown):ClaimWarning|null{
 const w=(raw as {warning?:unknown})?.warning as Record<string,unknown>|null|undefined;
 if(!w||!str(w.refused_request_id)||!str(w.building)||!Array.isArray(w.warnings)||!w.warnings.length||!Array.isArray(w.edits))return null;
 const warnings:ClaimWarningLine[]=[];
 for(const x of w.warnings as Array<Record<string,unknown>>){
  if(!x||!str(x.scene_id)||!str(x.text)||!Array.isArray(x.features)||!x.features.length)return null;
  const features=(x.features as Array<Record<string,unknown>>).filter(f=>f&&str(f.key)&&str(f.label)).map(f=>({key:f.key as string,label:f.label as string}));
  if(features.length!==x.features.length)return null;
  warnings.push({scene_id:x.scene_id,text:x.text,features,records_say:str(x.records_say)?x.records_say:null});
 }
 const edits=(w.edits as Array<Record<string,unknown>>).filter(e=>e&&str(e.scene_id)&&str(e.before)&&str(e.after)).map(e=>({scene_id:e.scene_id as string,before:e.before as string,after:e.after as string}));
 if(edits.length!==w.edits.length)return null;
 return {refused_request_id:w.refused_request_id,building:w.building,warnings,edits};
}
export const claimVouchService={
 warning:async(id:string)=>parseClaimWarning(await fetchWithAuth<unknown>(`/admin/content/reviews/${encodeURIComponent(id)}/copy/warning`)),
 vouch:async(id:string,body:{request_id:string;refused_request_id:string;vouched:Array<{scene_id:string;keys:string[]}>})=>
  fetchWithAuth<{request_id:string;state:string;approved_by?:string|null}>(`/admin/content/reviews/${encodeURIComponent(id)}/copy/vouch`,{method:'POST',body:JSON.stringify(body)}),
};
